export const partners = [
  {
    name: "Microsoft",
    type: "Authorised Partner",
    isMicrosoft: true,
    logo: "/images/partners-clients/microsoft-partner.png",
  },
  {
    name: "MTN Group",
    type: "Operator Partner",
    logo: "/images/partners-clients/mtn.svg",
  },
  {
    name: "Sentech",
    type: "Strategic Partner",
    logo: "/images/partners-clients/sentech.png",
    logoClass: "h-24 max-w-[200px]",
  },
  {
    name: "Huawei",
    type: "Technology Partner",
    logo: "/images/partners-clients/huawei.png",
  },
  {
    name: "Adapt IT",
    type: "Technology Partner",
    logo: "/images/partners-clients/adapt-it.svg",
  },
  {
    name: "World Bank Group",
    type: "Development Partner",
    logo: "/images/partners-clients/world-bank-group.png",
  },
  {
    name: "Falcorp",
    type: "Strategic Partner",
    logo: "/images/partners-clients/falcorp.svg",
  },
  { name: "GMHC", type: "Client", logo: "/images/partners-clients/gmhc.svg" },
  { name: "KNM", type: "Partner", logo: "/images/partners-clients/knm.png" },
];
